// services/kyc/badgeUi.ts
//
// The profile widget's badge, as a PURE function of derived KYC state. Replaces the
// `KycLevelFromToken === 3` token check. Achieved-level labels: پایه (0) / متوسط (1) / پیشرفته (2).

import type { KycState } from './derive';

export interface KycBadgeUi {
  /** Semantic tone — the widget maps this to `palette` via useTheme(), never a raw hex. */
  tone: 'default' | 'info' | 'success' | 'warning' | 'error' | 'neutral';
  label: string;
  action?: string;
}

export function selectKycBadgeUi(
  s: Pick<KycState, 'basic' | 'advanced'>
): KycBadgeUi {
  const a = s.advanced.status;
  if (a === 'approved') return { tone: 'success', label: 'پیشرفته' };
  if (a === 'under_review')
    return { tone: 'warning', label: 'در حال بررسی', action: 'مشاهده' };
  if (a === 'rejected')
    return { tone: 'error', label: 'رد شده', action: 'اصلاح' };

  const b = s.basic.status;
  if (b === 'approved')
    return { tone: 'info', label: 'متوسط', action: 'ارتقا احراز هویت' };
  if (b === 'under_review')
    return { tone: 'warning', label: 'در حال بررسی', action: 'مشاهده' };
  if (b === 'rejected')
    return { tone: 'error', label: 'رد شده', action: 'اصلاح احراز هویت' };

  return { tone: 'default', label: 'پایه', action: 'تکمیل احراز هویت' };
}
